// extracted by mini-css-extract-plugin
export var aboutTraining = "personal-training-module--about-training--a1caf";
export var calendar = "personal-training-module--calendar--970a4";
export var dateRange = "personal-training-module--date-range--349f8";
export var entryMovie = "personal-training-module--entry-movie--af6f5";
export var header = "personal-training-module--header--e0070";
export var horizontalLineEntryMovie = "personal-training-module--horizontal-line-entry-movie--66621";
export var horizontalLineMoviePlayerTitle = "personal-training-module--horizontal-line-movie-player-title--42c1b";
export var horizontalLineTitleDescription = "personal-training-module--horizontal-line-title-description--24c9d";
export var image_wrapper = "personal-training-module--image_wrapper--ac94d";
export var noTrainingInfo = "personal-training-module--no-training-info--812a7";
export var textStart = "personal-training-module--text-start--d1ce0";
export var tips = "personal-training-module--tips--147db";
export var toDo = "personal-training-module--to-do--ba499";
export var trainingTitle = "personal-training-module--training-title--27ab9";
export var wrapper = "personal-training-module--wrapper--8a4a7";